import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

export interface ReloadButtonProps {
  onReload: () => void;
}

export const ReloadButton: React.FC<ReloadButtonProps> = ({ onReload }) => {
  return (
    <Tooltip title="Recharger">
      <IconButton onClick={onReload} size="small">
        <RefreshIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
